// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper___3opzK","column":"column___3lF65","smallColumn":"smallColumn___GDdeC","row":"row___3sD5e","column1":"column1___2bhgK","column3":"column3___1ez1Z","column2":"column2___a0x0R","column4":"column4___2MF6o","backer":"backer___SAijf","select":"select___1Y8CR","option":"option___3tzmc","label":"label___1uGiE","switch":"switch___24D0R","switchBtn":"switchBtn___3V0f8","add":"add___2D9jk","remove":"remove___2wpAd","input":"input___IPMkO","vars":"vars___3MwaM"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/EditVariable/ChoiceFromDataSourceEditor/styles.scss
// module id = 414
// module chunks = 0